import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../../actions/authActions";

const Header = ({ auth: { isAuthenticated }, logout }) => {
  return (
    <nav className="navbar sticky-top navbar-expand-lg navbar-light bg-white py-2 px-1">
      <div className="container">
        <a href="/" className="navbar-brand">
          {/* <b>PIMA COVID-19 VACCINE & TEST CENTERS</b> */}
          <b>PIMA COVID-19 VACCINE CENTERS</b>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse ml-auto"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav ml-auto">
            {/* <li className="nav-item">
              <Link to="/" className="nav-link active">
                Testing
              </Link>
            </li> */}
            <li className="nav-item">
              <Link to="/" className="nav-link active">
                Vaccination
              </Link>
            </li>
            {isAuthenticated ? (
              <>
                <li className="nav-item">
                  <Link to="/admin/testcenters" className="nav-link active">
                    Admin Panel
                  </Link>
                </li>
                <li className="nav-item">
                  <a onClick={logout} href="#!" className="nav-link active">
                    Logout
                  </a>
                </li>
              </>
            ) : null}
            {/* <li className="nav-item">
              <a
                className="nav-link active"
                href="https://webcms.pima.gov/cms/One.aspx?portalId=169&pageId=641145"
              >
                Progress Report
              </a>
            </li>

            <li className="nav-item">
              <a
                href="https://webcms.pima.gov/cms/One.aspx?portalId=169&pageId=641109"
                className="nav-link active border px-2"
              >
                Covid-19 Dashboard
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

Header.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { logout })(Header);
//
